import { Eye, EyeOff, Lock, Unlock, ChevronUp, ChevronDown, Trash2, Type, Square, Circle, Image as ImageIcon, QrCode, Barcode } from "lucide-react";

const ICON = { text: Type, rect: Square, ellipse: Circle, image: ImageIcon, qr: QrCode, barcode: Barcode };

const label = (el) => {
  if (el.type === "text") return el.text?.slice(0, 26) || "Text";
  if (el.type === "image") return el.field ? `Image · ${el.field}` : "Image";
  if (el.type === "qr") return `QR · ${el.value?.slice(0, 18)}`;
  if (el.type === "barcode") return `Barcode · ${el.value?.slice(0, 16)}`;
  return el.type === "ellipse" ? "Circle" : "Rectangle";
};

export default function LayersPanel({ tpl, side, sel, setSel, updateEl, moveLayer, removeEl }) {
  const els = [...tpl[side].elements].reverse();
  if (!els.length) return <p className="text-xs text-slate-500" data-testid="layers-empty">No elements on the {side} yet.</p>;
  return (
    <ul className="space-y-1" data-testid="layers-list">
      {els.map((el) => {
        const Icon = ICON[el.type] || Square;
        return (
          <li key={el.id} onClick={() => setSel(el.id)} data-testid={`layer-item-${el.id}`}
            className={`group flex items-center gap-2 px-2 h-9 rounded-md cursor-pointer text-xs border transition-colors ${sel === el.id ? "bg-amber-500/10 border-amber-500/40 text-white" : "border-transparent hover:bg-slate-800 text-slate-300"}`}>
            <Icon size={13} className="shrink-0 text-slate-500" />
            <span className={`flex-1 truncate ${el.hidden ? "opacity-40" : ""}`}>{label(el)}</span>
            <div className="flex items-center opacity-60 group-hover:opacity-100" onClick={(e) => e.stopPropagation()}>
              <B onClick={() => moveLayer(el.id, "up")} t={`layer-up-${el.id}`}><ChevronUp size={13} /></B>
              <B onClick={() => moveLayer(el.id, "down")} t={`layer-down-${el.id}`}><ChevronDown size={13} /></B>
              <B onClick={() => updateEl(el.id, { hidden: !el.hidden })} t={`layer-visibility-${el.id}`}>{el.hidden ? <EyeOff size={13} /> : <Eye size={13} />}</B>
              <B onClick={() => updateEl(el.id, { locked: !el.locked })} t={`layer-lock-${el.id}`}>{el.locked ? <Lock size={13} className="text-amber-400" /> : <Unlock size={13} />}</B>
              <B onClick={() => removeEl(el.id)} t={`layer-delete-${el.id}`}><Trash2 size={13} /></B>
            </div>
          </li>
        );
      })}
    </ul>
  );
}

const B = ({ children, onClick, t }) => (
  <button onClick={onClick} data-testid={t} className="p-1 rounded hover:bg-slate-700">{children}</button>
);
